import apiService from "service/api";

export const getBusinessWallet = async (hfId: number) => {
  return apiService(`/wallet/business/${hfId}/`, "GET", undefined, true);
};

export const getBusinessWalletTransactions = (hfId: number | undefined, page: any, size: number) => {
  return apiService(`/wallet/business/${hfId}/transactions/?page=${page}&size=${size}`, "GET", null, true);
};


export const getAllAccounts = () => {
  return apiService("/wallet/business-bank-account/", "GET", null, true);
};

export const getTransactionsMetrics = (hfid: number | undefined) => {
  return apiService(`/wallet/business/${hfid}/total-metrics/`, "GET", null, true);
};

export const getAllTransactionsMetrics = (hfid: number | undefined, page: any, size: number) => {
  return apiService(`/wallet/business/${hfid}/metrics/?page=${page}&size=${size}`, "GET", null, true);
};


export const getBanks = (params: {
  format?: "json" | "datatables";
  name?: string;
  page?: number;
  page_size?: number;
} = {}) => {
  return apiService(`/wallet/banks/?page=${1}&size=${5000}`, "GET", null, true, undefined, undefined, params);
};


export const getAllBusinessBankAccounts = (hfId: number, page: any, size: number) => {
  return apiService(
    `/wallet/business/${hfId}/bank-accounts/?page=${page}&size=${size}`,
    "GET",
    null,
    true
  );
};

export const addBusinessBankAccount = (
  hfId: number,
  formData: Record<string, any>
) => {
  return apiService(
    `/wallet/business/${hfId}/bank-accounts/`,
    "POST",
    formData,
    true
  );
};


export const createBusinessPin = (
  hfId: number,
  pin_1: string, pin_2: string
) => {
  return apiService(
    `/wallet/business/${hfId}/transaction-pin/`,
    "POST",
    { pin_1, pin_2 },
    true
  );
};



export const deleteBusinessBankAccount = (hfId: number, accountId: number) => {
  return apiService(
    `/wallet/business/${hfId}/bank-account/${accountId}/`,
    "DELETE",
    null,
    true
  );
};


export const fundBusinessWallet = (hfid: number | undefined, gateway: string, amount: string) => {
  return apiService(
    `/wallet/business/${hfid}/deposit/?payment_gateway=${gateway}`,
    "POST",
    { amount },
    true
  );
};

export const updateBusinessBankAccount = (
  hfId: number,
  bankAccountId: number,
  formData: Record<string, any>,
  params: {
    format?: "json" | "datatables";
  }

) => {
  return apiService(
    `/wallet/business/${hfId}/bank-account/${bankAccountId}/`,
    "PUT",
    formData,
    true,
    undefined,
    undefined,
    params
  );
};



export const withdrawRequest = (
  payload: {
    business_bank_account: number;
    amount: number;
  }
  ,
  params: {
    format?: "json" | "datatables";
  }
    = {}
) => {
  return apiService(
    "/wallet/withdraw-request/",
    "POST",
    payload,
    true,
    undefined,
    undefined,
    params
  );
};

export const validateBankAccount = async (
  account_number: string,
  bank_code: string,
  format?: "json" | "datatables") => {
  return apiService(`/wallet/banks/validate-bank-account/?account_number=${account_number}&bank_code=${bank_code}`, "GET", null, true, undefined, undefined,);
};